"use strict";

import angular from "angular";

const name = "marginLevel";
const factory = [
    () => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            const multiplier = Number($attr.marginMultiplier) || 16;
            const defineMargLeft = () => {
                const level = Number($attr.marginLevel);
                const marginLeft = (level + 1) * multiplier;
                $elem[0].style.marginLeft = `${marginLeft}px`;
            };
            defineMargLeft();
            $scope.$watch(
                () => $attr.marginLevel,
                (newValue) => {
                    if (newValue) defineMargLeft();
                }
            );
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
